import React from "react";

const Blastoise = ({ ...rest }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      viewBox="5.75 -2.15 326.35 413.25"
      {...rest}
    >
      <g>
        <path
          fill="#6f4e25"
          d="M233.05 83.05 Q258.5 98.75 275.35 121.95 293.75 147.3 298.15 177.05 227.7 179.15 158.45 176.0 20.0 169.65 26.2 143.4 33.45 112.85 85.7 86.65 111.8 73.55 136.45 66.55 156.65 58.9 182.9 63.5 208.75 68.0 233.05 83.05"
        />
        <path
          fill="#4a311c"
          d="M172.55 61.95 L185.15 63.3 Q169.25 69.0 155.2 80.2 144.65 88.65 133.35 101.9 128.3 96.15 120.95 89.05 L107.8 76.65 Q138.5 64.05 157.75 62.1 165.05 61.4 172.55 61.95"
        />
        <path
          fill="#4a311c"
          d="M279.1 127.4 Q294.2 150.6 298.15 177.05 281.8 177.55 257.1 177.7 270.95 156.45 279.1 127.4"
        />
        <path
          fill="#6f4e25"
          d="M134.95 60.3 Q139.2 72.5 139.7 77.55 L118.85 134.35 53.45 127.65 Q51.25 125.6 42.1 110.25 32.45 94.05 31.75 89.9 30.35 82.15 76.15 59.5 91.5 51.9 107.65 47.95 118.75 45.25 125.2 45.1 129.6 45.0 134.95 60.3"
        />
        <path
          fill="#4a311c"
          d="M134.95 60.3 Q139.2 72.5 139.7 77.55 L125.2 117.0 Q116.75 105.0 94.9 80.7 75.95 59.6 76.15 59.5 91.5 51.9 107.65 47.95 118.75 45.25 125.2 45.1 129.6 45.0 134.95 60.3"
        />
        <path
          fill="#6f4e25"
          d="M277.05 95.35 Q292.1 107.65 301.6 118.6 311.7 130.2 310.05 134.1 308.55 137.65 294.45 150.3 281.5 161.95 278.6 163.6 L208.25 120.35 221.8 86.9 Q223.05 83.25 226.9 77.35 231.9 69.65 234.85 70.4 239.95 71.7 250.5 77.4 264.45 85.0 277.05 95.35"
        />
        <path
          fill="#4a311c"
          d="M302.35 119.5 Q311.65 130.4 310.05 134.1 309.3 135.85 303.25 142.0 L292.2 152.7 280.85 150.25 Q272.9 148.7 265.55 148.7 271.1 140.05 275.8 119.4 279.65 102.3 279.45 97.35 293.65 109.3 302.35 119.5"
        />
        <path
          fill="#0d131a"
          d="M122.7 63.0 Q125.7 68.4 127.35 74.15 L128.9 78.55 Q130.65 83.95 131.45 89.05 133.9 105.4 125.9 112.7 117.85 120.0 91.4 123.3 78.15 125.0 66.5 125.2 61.75 119.95 53.9 107.5 45.3 93.9 45.75 90.85 46.2 87.45 77.35 72.65 108.55 57.85 117.05 57.05 119.3 56.8 122.7 63.0"
        />
        <path
          fill="#0d131a"
          d="M238.05 84.0 Q242.7 85.7 269.35 107.2 296.6 129.15 296.35 132.1 296.1 135.0 284.9 146.1 274.55 156.35 269.1 160.1 L221.15 113.65 Q224.85 103.2 228.45 95.7 234.6 82.8 238.05 84.0"
        />
        <path
          fill="#dcdbd6"
          d="M240.6 104.55 Q253.95 103.8 266.05 115.5 270.7 120.0 273.85 125.25 276.75 130.1 277.05 133.3 277.75 140.55 274.4 145.9 270.25 152.6 260.55 154.4 L229.8 139.3 224.1 119.5 Q225.15 114.4 227.9 110.85 232.4 105.05 240.6 104.55"
        />
        <path
          fill="#b4b4b0"
          d="M277.05 133.3 Q277.75 140.55 274.4 145.9 270.25 152.6 260.55 154.4 L250.15 149.3 259.25 110.3 267.95 119.6 Q276.7 129.6 277.05 133.3"
        />
        <path
          fill="#dcdbd6"
          d="M240.55 140.95 Q232.35 134.95 231.0 126.8 229.8 119.1 235.45 114.25 239.4 110.85 243.65 110.3 L269.35 132.95 Q270.45 139.45 265.35 143.6 260.65 147.35 254.4 146.75 247.55 146.1 240.55 140.95"
        />
        <path
          fill="#b4b4b0"
          d="M269.35 132.95 Q270.45 139.45 265.35 143.6 260.65 147.35 254.4 146.75 L250.6 145.95 252.35 129.55 253.35 119.75 269.35 132.95"
        />
        <path
          fill="#dcdbd6"
          d="M329.7 81.45 Q328.85 88.35 325.4 94.55 322.2 100.35 317.7 103.8 310.05 109.65 294.7 119.7 280.55 128.95 274.75 132.15 269.6 135.05 262.95 134.5 256.35 134.0 249.45 130.25 243.0 126.75 240.5 119.05 238.3 112.2 240.2 106.45 242.1 100.7 250.7 81.55 259.6 61.6 262.1 58.15 266.0 52.65 272.75 48.65 279.6 44.65 287.45 43.25 305.8 40.0 318.1 51.6 331.75 64.45 329.7 81.45"
        />
        <path
          fill="#b4b4b0"
          d="M285.75 110.95 Q299.15 114.25 311.5 108.3 302.7 114.55 290.7 122.3 L274.75 132.15 Q269.6 135.05 262.95 134.5 256.35 134.0 249.45 130.25 249.15 130.1 259.3 118.3 L270.15 105.7 271.35 104.5 Q272.1 104.25 273.5 105.5 277.15 108.8 285.75 110.95"
        />
        <path
          fill="#dcdbd6"
          d="M87.25 78.5 Q102.4 71.85 118.4 77.7 L124.35 105.8 80.1 127.0 Q70.7 122.8 68.15 114.85 66.35 109.1 68.15 101.1 71.65 85.4 87.25 78.5"
        />
        <path
          fill="#b4b4b0"
          d="M92.75 76.55 Q105.7 73.05 118.4 77.7 L124.35 105.8 Q113.7 104.15 101.95 101.35 78.45 95.8 72.8 90.25 79.75 80.1 92.75 76.55"
        />
        <path
          fill="#dcdbd6"
          d="M113.2 88.75 Q116.65 94.95 113.5 102.7 110.15 110.85 102.1 114.55 95.35 117.6 88.25 116.65 81.65 115.8 76.7 109.45 71.4 102.65 74.1 96.15 L107.0 82.85 Q110.7 84.25 113.2 88.75"
        />
        <path
          fill="#b4b4b0"
          d="M107.0 82.85 Q110.7 84.25 113.2 88.75 116.65 94.95 113.5 102.7 110.15 110.9 102.1 114.5 L94.8 104.9 91.35 100.65 107.0 82.85"
        />
        <path
          fill="#dcdbd6"
          d="M107.1 95.25 Q102.95 102.0 95.55 104.05 87.35 106.3 80.55 105.45 73.5 104.5 68.95 100.35 62.85 94.8 53.1 84.85 41.1 72.65 34.85 65.05 31.0 60.35 28.85 53.05 26.55 45.2 27.1 37.15 28.45 17.2 45.6 7.2 61.55 -2.15 78.45 4.05 94.55 9.95 102.5 26.2 104.65 30.6 107.85 52.2 111.1 74.0 110.8 82.85 110.55 89.65 107.1 95.25"
        />
        <path
          fill="#b4b4b0"
          d="M109.15 61.5 Q111.0 76.5 110.8 82.85 110.55 89.65 107.1 95.25 102.95 102.0 95.55 104.05 L93.5 104.95 Q92.75 105.25 92.4 104.65 80.65 83.65 78.75 79.45 77.4 76.5 77.4 76.05 77.35 75.15 79.15 74.65 91.6 70.85 98.95 60.65 106.7 49.8 105.15 36.3 107.35 47.4 109.15 61.5"
        />
        <path
          fill="#dbdcdc"
          d="M186.55 350.5 Q190.0 349.85 194.15 355.65 198.3 361.3 198.75 367.0 196.5 369.85 183.4 367.9 170.85 365.95 169.1 363.8 167.7 362.0 174.75 356.7 181.7 351.4 186.55 350.5"
        />
        <path
          fill="#eeeeef"
          d="M201.6 93.95 Q210.35 100.15 222.35 114.2 232.85 126.45 240.2 133.45 251.55 144.3 261.75 149.4 289.25 163.15 299.9 175.95 313.25 192.05 304.4 210.45 L27.4 206.15 Q24.35 204.65 20.5 199.65 16.45 194.35 13.5 187.65 6.05 170.5 11.0 157.5 15.25 146.35 28.05 137.15 42.4 126.9 60.1 125.15 L71.2 124.25 Q77.25 123.7 81.45 122.55 92.55 119.5 103.65 108.65 118.85 93.75 134.2 87.25 149.8 80.6 167.35 81.8 186.45 83.15 201.6 93.95"
        />
        <path
          fill="#c8c9ca"
          d="M11.0 157.5 L11.8 155.65 Q13.8 182.0 33.75 193.45 42.45 198.45 56.15 201.85 66.45 204.4 84.7 207.05 L27.4 206.15 Q24.35 204.65 20.5 199.65 16.45 194.35 13.5 187.65 6.05 170.5 11.0 157.5"
        />
        <path
          fill="#c8c9ca"
          d="M167.35 81.8 Q186.45 83.15 201.6 93.95 210.35 100.15 222.35 114.2 228.25 121.1 234.5 127.65 243.45 137.1 249.35 141.8 232.35 146.7 217.0 167.6 204.55 184.5 195.2 208.75 L170.0 208.35 Q168.8 173.45 146.15 144.5 136.05 131.6 123.85 123.35 111.6 115.0 99.75 113.05 112.8 99.2 132.35 90.05 152.25 80.75 167.35 81.8"
        />
        <path
          fill="#c8c9ca"
          d="M280.35 159.75 Q298.05 170.95 304.3 182.35 311.55 195.55 304.4 210.45 L277.3 200.55 Q282.6 196.2 285.65 188.95 291.7 174.4 280.35 159.75"
        />
        <path
          fill="#0d131a"
          d="M208.55 182.45 Q188.85 192.55 162.35 190.4 135.85 188.3 118.05 175.2 100.25 162.1 101.55 145.65 102.85 129.25 122.55 119.1 142.2 109.0 168.7 111.1 195.2 113.25 213.0 126.35 230.8 139.45 229.5 155.9 228.2 172.35 208.55 182.45"
        />
        <path
          fill="#3396cd"
          d="M182.6 344.35 Q187.35 339.2 197.2 337.7 207.05 336.15 237.0 343.8 251.95 347.65 264.95 351.75 266.75 357.45 260.85 364.8 255.3 371.75 246.3 376.2 233.45 382.55 217.75 381.85 201.4 381.15 188.65 372.95 182.0 368.65 179.75 359.8 177.9 352.35 179.85 349.2 180.25 346.95 182.6 344.35"
        />
        <path
          fill="#2880ae"
          d="M182.6 344.35 Q187.35 339.2 197.2 337.7 199.65 337.3 204.2 337.55 211.25 343.1 216.0 351.8 202.1 348.6 193.2 352.15 185.6 355.25 181.05 363.7 179.25 359.45 179.0 354.9 178.8 350.85 179.85 349.2 180.25 346.95 182.6 344.35"
        />
        <path
          fill="#2880ae"
          d="M231.3 380.7 Q220.7 382.55 212.0 381.25 226.5 371.4 216.4 352.6 L240.25 351.55 Q253.95 351.1 264.1 351.5 L264.95 351.75 Q266.75 357.45 260.85 364.8 255.3 371.75 246.3 376.2 240.35 379.1 231.3 380.7"
        />
        <path
          fill="#c8c9ca"
          d="M30.1 290.15 Q20.3 275.05 18.9 250.45 18.0 235.55 19.85 224.85 L41.95 229.9 49.5 292.8 30.1 290.15"
        />
        <path
          fill="#3396cd"
          d="M278.45 292.15 Q284.45 306.05 282.05 322.4 279.6 338.9 273.05 346.65 269.6 350.75 262.5 353.8 250.95 358.8 237.95 358.8 214.4 358.85 195.9 341.55 202.75 328.4 211.75 313.7 229.75 284.3 240.6 276.5 251.5 268.7 260.95 271.85 265.7 273.4 268.25 276.5 275.1 284.45 278.45 292.15"
        />
        <path
          fill="#2880ae"
          d="M268.25 276.5 Q275.1 284.45 278.45 292.15 284.45 306.05 282.05 322.4 279.55 339.3 274.3 345.9 272.15 348.6 268.85 350.55 L262.5 353.8 Q255.25 357.35 248.35 358.65 L231.75 359.2 Q238.2 355.1 237.65 349.35 237.15 344.1 231.3 339.85 225.35 335.55 217.35 334.9 208.4 334.2 200.45 338.65 212.6 316.8 220.1 304.3 233.9 281.35 240.6 276.5 251.5 268.7 260.95 271.85 265.7 273.4 268.25 276.5"
        />
        <path
          fill="#ffffff"
          d="M191.1 372.45 Q196.4 368.4 203.85 369.0 212.95 369.7 220.8 377.55 223.8 380.55 215.25 387.05 207.35 393.05 203.95 393.25 201.55 393.4 196.05 384.9 190.45 376.25 191.1 372.45"
        />
        <path
          fill="#dbdcdc"
          d="M220.8 377.55 Q223.25 380.0 216.0 386.25 210.0 391.45 203.85 394.5 207.4 389.95 209.65 383.15 211.8 376.4 211.55 371.0 216.4 373.15 220.8 377.55"
        />
        <path
          fill="#ffffff"
          d="M236.0 371.55 Q247.3 367.4 256.0 370.65 260.9 372.5 265.15 384.6 266.9 389.65 267.15 393.2 267.4 397.1 265.6 397.45 258.95 398.8 243.1 391.4 226.75 383.85 226.15 377.95 226.05 377.0 228.85 375.1 231.85 373.05 236.0 371.55"
        />
        <path
          fill="#dbdcdc"
          d="M256.0 370.65 Q260.2 372.25 264.3 382.3 268.25 392.15 266.85 396.15 263.9 388.3 258.65 380.7 252.9 372.45 247.5 369.3 252.25 369.2 256.0 370.65"
        />
        <path
          fill="#f0e9a5"
          d="M201.45 169.9 Q215.3 164.45 222.1 156.15 225.8 151.65 232.45 153.75 238.55 155.7 241.4 160.75 243.7 164.9 244.2 174.1 244.55 181.3 243.8 187.75 243.4 191.05 247.1 237.15 250.0 283.9 245.7 293.35 239.5 306.9 228.1 319.9 216.25 333.4 205.5 338.5 187.7 346.9 169.9 350.25 141.5 355.6 115.9 347.7 100.8 344.15 84.25 334.2 51.15 314.3 43.75 282.5 36.4 250.7 59.05 199.05 70.4 173.2 83.2 153.7 83.6 150.7 88.8 145.0 94.55 138.65 98.4 139.2 101.95 139.65 108.45 146.05 L120.55 158.4 Q126.95 164.45 140.05 169.7 155.9 176.05 170.55 175.8 187.05 175.55 201.45 169.9"
        />
        <path
          fill="#c9c48b"
          d="M89.45 144.25 Q91.3 143.45 93.15 143.3 L98.25 143.7 Q93.6 147.9 91.3 152.8 89.3 157.2 88.7 163.25 85.45 157.95 83.5 152.6 84.15 151.05 85.75 148.75 87.45 146.35 89.45 144.25"
        />
        <path
          fill="#c9c48b"
          d="M68.8 280.2 Q57.45 278.85 43.5 281.2 41.65 272.5 42.1 262.15 48.3 264.85 55.0 265.35 61.6 265.85 68.05 264.1 68.15 272.15 68.8 280.2"
        />
        <path
          fill="#c9c48b"
          d="M191.65 178.95 Q191.5 177.7 189.4 176.15 187.8 175.0 186.05 174.25 197.9 172.0 207.55 167.15 217.0 162.35 222.1 156.15 225.8 151.65 232.45 153.75 238.55 155.7 241.4 160.75 243.7 164.9 244.2 174.1 244.55 181.3 243.8 187.75 243.4 191.05 247.1 237.15 250.0 283.9 245.7 293.35 239.5 306.9 228.1 319.9 216.25 333.4 205.5 338.5 186.55 347.45 168.9 351.0 139.55 356.8 115.9 347.7 108.75 346.0 98.9 341.7 106.65 339.8 112.35 332.65 114.6 329.8 118.4 322.5 144.0 315.95 162.6 291.75 163.05 291.2 163.35 289.45 L163.55 287.85 Q165.45 287.9 165.8 287.35 181.3 265.05 188.15 234.55 188.35 233.75 187.9 232.1 L187.45 230.55 Q189.15 229.8 189.25 229.3 194.25 203.5 191.65 178.95"
        />
        <path
          fill="#3396cd"
          d="M48.4 395.4 Q28.55 395.75 19.2 380.0 8.2 361.45 15.55 324.55 L115.9 313.8 Q120.7 328.35 116.25 353.35 111.85 377.95 103.65 385.35 96.0 392.3 77.55 394.35 L48.4 395.4"
        />
        <path
          fill="#2880ae"
          d="M77.55 394.35 L48.4 395.4 Q68.0 378.2 48.75 356.9 L115.9 313.8 Q120.7 328.35 116.25 353.35 111.85 377.95 103.65 385.35 96.0 392.3 77.55 394.35"
        />
        <path
          fill="#ffffff"
          d="M113.9 386.55 Q114.9 397.6 111.75 399.6 108.5 401.7 99.55 399.65 90.4 397.55 85.3 393.3 83.85 392.1 84.7 388.45 85.6 384.55 88.45 381.05 96.25 371.55 109.8 374.8 112.9 375.55 113.9 386.55"
        />
        <path
          fill="#ffffff"
          d="M21.5 384.05 Q22.5 378.55 30.3 377.4 35.6 376.55 49.25 377.6 61.05 378.5 70.65 382.8 80.75 387.35 80.45 392.35 80.15 397.6 61.25 403.6 42.2 409.7 28.1 408.85 23.05 408.55 21.35 400.0 19.9 392.6 21.5 384.05"
        />
        <path
          fill="#dbdcdc"
          d="M113.9 386.55 Q114.9 397.6 111.75 399.6 108.5 401.7 99.55 399.65 90.4 397.55 85.3 393.3 83.85 392.1 84.7 388.45 85.6 384.55 88.45 381.05 96.25 371.55 109.8 374.8 112.9 375.55 113.9 386.55"
        />
        <path
          fill="#dbdcdc"
          d="M62.3 379.85 Q70.35 382.05 75.3 385.3 80.65 388.8 80.45 392.35 80.2 397.4 62.35 403.3 44.5 409.2 30.1 408.95 43.2 405.25 53.05 397.55 64.65 388.45 62.3 379.85"
        />
        <path
          fill="#3396cd"
          d="M60.35 273.45 L72.1 272.45 Q93.1 273.15 105.35 286.9 115.95 298.85 116.7 315.75 117.3 328.3 107.2 341.7 96.8 355.55 82.15 360.25 76.35 362.1 63.25 361.15 52.85 360.35 42.3 358.25 24.45 354.7 18.25 337.8 14.45 327.35 15.35 312.15 16.2 298.9 25.4 288.0 37.9 273.1 60.35 273.45"
        />
        <path
          fill="#2880ae"
          d="M63.25 361.15 Q52.85 360.35 42.3 358.25 29.55 355.75 22.65 346.2 31.35 351.25 41.5 350.9 53.6 350.45 64.05 342.0 79.0 329.95 84.7 312.75 92.1 290.4 76.3 272.75 95.3 274.75 106.35 288.1 116.0 299.8 116.7 315.75 117.3 328.3 107.2 341.7 96.8 355.55 82.15 360.25 76.35 362.1 63.25 361.15"
        />
        <path
          fill="#3396cd"
          d="M17.25 182.4 Q18.5 172.7 24.55 164.35 30.8 155.75 40.65 150.75 51.2 145.35 63.95 145.25 82.8 145.05 87.3 161.35 88.95 167.25 88.3 174.2 87.75 180.05 86.05 183.45 72.45 193.95 57.45 201.45 27.4 216.4 20.2 201.3 16.0 192.4 17.25 182.4"
        />
        <path
          fill="#2880ae"
          d="M56.35 145.85 L63.95 145.25 Q82.8 145.05 87.3 161.35 88.95 167.25 88.3 174.2 87.75 180.05 86.05 183.45 80.05 187.8 71.75 191.45 55.05 198.7 43.3 195.1 57.1 181.4 61.65 167.15 66.6 151.6 56.35 145.85"
        />
        <path
          fill="#3396cd"
          d="M40.5 179.5 Q56.4 171.5 68.65 174.0 83.05 176.95 88.2 188.85 90.35 193.8 90.15 199.05 89.95 204.15 87.6 207.95 L30.0 233.6 Q18.05 228.6 16.45 216.55 15.1 206.65 20.6 196.3 25.6 187.0 40.5 179.5"
        />
        <path
          fill="#2880ae"
          d="M62.25 173.5 L68.65 174.0 Q83.05 176.95 88.2 188.85 90.35 193.8 90.15 199.05 89.95 204.15 87.6 207.95 L60.7 217.55 Q61.8 216.6 64.1 212.65 67.2 207.35 68.8 201.8 73.6 184.9 62.25 173.5"
        />
        <path
          fill="#ffffff"
          d="M36.4 268.35 L30.4 254.25 52.35 261.9 50.15 269.0 Q47.3 276.3 44.15 277.25 41.0 278.2 36.4 268.35"
        />
        <path
          fill="#dbdcdc"
          d="M45.05 259.35 L52.35 261.9 50.15 269.0 Q47.3 276.3 44.15 277.25 44.05 277.3 44.9 271.35 45.9 264.05 45.05 259.35"
        />
        <path
          fill="#ffffff"
          d="M99.9 254.4 Q99.85 259.2 99.05 263.0 98.3 266.7 97.4 267.0 95.85 267.5 87.95 262.4 80.5 257.6 79.7 256.4 L94.55 236.05 Q99.9 241.65 99.9 254.4"
        />
        <path
          fill="#dbdcdc"
          d="M86.75 246.75 L94.55 236.05 Q99.15 240.9 100.25 249.8 101.35 259.15 97.85 267.7 97.25 262.15 93.85 256.0 90.75 250.35 86.75 246.75"
        />
        <path
          fill="#ffffff"
          d="M78.2 256.55 Q78.9 260.25 76.3 270.55 73.45 281.55 70.6 281.05 67.0 280.4 62.0 274.95 56.3 268.8 53.05 260.7 L78.2 256.55"
        />
        <path
          fill="#dbdcdc"
          d="M78.2 256.55 Q78.9 260.25 76.3 270.55 73.45 281.55 70.6 281.05 L70.0 275.2 Q69.25 267.25 66.1 258.55 L78.2 256.55"
        />
        <path
          fill="#3396cd"
          d="M89.85 211.3 Q95.1 215.7 96.55 220.7 99.65 231.2 91.8 244.7 83.45 259.05 69.95 262.35 54.8 266.05 40.8 261.15 25.8 255.85 24.15 244.0 22.45 231.95 27.5 222.5 32.2 213.7 42.15 208.15 59.0 198.75 77.0 204.4 84.5 206.8 89.85 211.3"
        />
        <path
          fill="#2880ae"
          d="M96.55 220.7 Q99.65 231.2 91.8 244.7 83.45 259.05 69.95 262.35 L67.7 262.85 Q79.4 251.65 80.8 233.85 82.25 215.6 71.6 203.1 80.95 204.75 88.0 209.85 94.8 214.8 96.55 220.7"
        />
        <path
          fill="#3396cd"
          d="M286.6 184.45 Q299.55 191.45 304.0 208.05 307.75 222.05 303.85 231.45 300.7 239.15 291.25 245.85 284.2 250.85 260.6 228.95 253.2 222.1 245.1 213.4 L238.4 206.05 Q237.15 198.6 242.85 191.0 248.95 182.8 258.85 181.0 274.8 178.1 286.6 184.45"
        />
        <path
          fill="#2880ae"
          d="M284.65 184.2 Q291.3 188.3 296.25 193.95 302.05 200.65 304.0 208.05 307.75 222.05 303.85 231.45 300.7 239.15 291.25 245.85 287.8 248.3 279.15 233.35 L271.2 217.95 274.7 216.7 Q278.8 214.9 281.7 211.85 290.95 202.15 284.65 184.2"
        />
        <path
          fill="#3396cd"
          d="M274.25 209.7 Q284.7 219.05 288.6 232.35 292.35 245.0 288.75 253.25 284.6 262.85 270.95 265.75 258.85 268.4 242.8 249.15 237.8 243.15 233.0 235.65 L229.2 229.4 Q227.1 222.55 230.9 214.05 235.8 203.1 248.45 201.1 262.2 198.9 274.25 209.7"
        />
        <path
          fill="#2880ae"
          d="M260.7 244.65 Q267.0 242.7 271.85 237.35 281.55 226.65 274.3 209.7 279.35 214.25 283.2 220.45 286.8 226.3 288.6 232.35 292.35 245.0 288.75 253.25 284.6 262.85 270.95 265.75 267.2 266.55 263.6 255.7 L260.7 244.65"
        />
        <path
          fill="#ffffff"
          d="M221.5 264.35 L216.9 265.55 Q211.85 266.65 209.7 266.15 207.3 265.65 211.9 255.85 216.35 246.4 219.35 243.75 L221.5 264.35"
        />
        <path
          fill="#dbdcdc"
          d="M209.7 266.15 L213.7 263.25 Q218.6 259.65 220.65 256.25 L221.5 264.35 216.9 265.55 Q211.85 266.65 209.7 266.15"
        />
        <path
          fill="#dbdcdc"
          d="M241.3 289.35 L230.7 290.65 Q228.85 290.65 230.6 285.35 232.2 280.3 233.9 278.55 L257.35 284.6 Q250.9 287.6 241.3 289.35"
        />
        <path
          fill="#ffffff"
          d="M221.8 263.9 L235.4 280.0 Q229.3 282.05 222.6 282.7 215.9 283.35 215.0 281.95 213.05 279.1 217.2 271.2 L221.8 263.9"
        />
        <path
          fill="#dbdcdc"
          d="M215.15 282.1 Q223.1 278.9 229.65 273.2 L235.4 280.0 Q229.5 281.95 222.95 282.65 216.45 283.3 215.15 282.1"
        />
        <path
          fill="#3396cd"
          d="M269.3 248.55 Q274.45 259.6 273.35 268.7 272.15 278.4 264.05 282.6 254.6 287.5 248.0 286.8 239.5 285.9 228.8 276.2 217.4 265.9 217.9 250.4 218.1 244.35 220.1 239.15 222.0 234.35 224.55 232.35 235.3 223.9 248.75 228.7 262.3 233.5 269.3 248.55"
        />
        <path
          fill="#2880ae"
          d="M269.3 248.55 Q274.45 259.6 273.35 268.7 272.15 278.4 264.05 282.6 254.6 287.5 248.0 286.8 239.5 285.9 228.8 276.2 L227.15 274.6 Q234.45 278.7 242.05 278.2 249.2 277.7 255.25 273.3 261.2 269.0 264.65 262.05 268.25 254.85 268.25 246.5 L269.3 248.55"
        />
        <path
          fill="#f0e9a5"
          d="M200.9 166.4 Q184.55 173.1 162.8 170.95 150.35 169.7 138.9 164.6 124.95 158.4 117.3 148.3 111.9 141.25 113.8 131.85 115.7 122.1 123.9 119.95 130.95 118.1 175.0 121.95 L217.7 126.15 Q226.85 155.85 200.9 166.4"
        />
        <path
          fill="#c9c48b"
          d="M208.0 127.9 Q213.55 126.3 217.7 126.15 226.85 155.85 200.9 166.4 184.55 173.1 162.8 170.95 151.95 169.8 142.05 165.9 L153.8 167.65 Q160.6 168.2 167.1 166.75 181.75 163.5 188.85 156.0 196.8 147.6 190.0 138.45 196.95 131.1 208.0 127.9"
        />
        <path
          fill="#3396cd"
          d="M174.7 77.1 Q178.5 72.55 190.85 76.6 200.75 79.85 205.0 83.35 212.25 82.6 218.4 83.65 223.8 84.55 225.6 86.3 227.2 87.85 225.0 95.55 222.85 103.05 219.25 109.2 221.85 115.6 222.05 123.9 222.25 132.6 219.45 135.5 L214.4 132.05 Q210.9 130.25 207.15 130.5 209.35 136.6 206.0 139.0 203.7 140.65 198.1 140.65 195.15 140.65 185.05 137.2 173.85 133.35 169.1 132.65 L152.8 131.9 136.1 132.3 Q122.1 132.35 128.65 120.85 121.5 120.15 117.65 123.95 115.3 126.25 114.95 128.7 113.15 122.4 114.4 114.15 115.7 105.3 119.8 100.75 117.9 95.4 116.9 89.3 114.95 77.05 119.4 73.15 120.8 71.9 127.3 73.1 134.1 74.4 139.4 77.2 148.15 72.95 160.2 72.65 172.65 72.4 174.7 77.1"
        />
        <path
          fill="#2880ae"
          d="M120.6 86.45 Q118.4 74.05 119.4 73.15 120.8 71.9 127.3 73.1 134.1 74.4 139.4 77.2 140.85 76.5 147.6 74.85 134.85 80.55 124.7 95.85 122.75 98.75 120.6 86.45"
        />
        <path
          fill="#2880ae"
          d="M164.8 72.95 Q169.9 72.85 171.9 73.75 173.6 74.55 174.7 77.1 178.5 72.55 190.85 76.6 200.75 79.85 205.0 83.35 212.25 82.6 218.4 83.65 223.8 84.55 225.6 86.3 227.2 87.85 225.0 95.55 222.85 103.05 219.25 109.2 221.85 115.6 222.05 123.9 222.25 132.6 219.45 135.5 L214.4 132.05 Q210.9 130.25 207.15 130.5 209.35 136.6 206.0 139.0 203.7 140.65 198.1 140.65 195.2 140.65 185.8 137.15 175.45 133.3 170.65 132.55 171.7 128.9 171.2 125.45 L170.45 122.7 171.9 122.55 174.25 122.9 Q176.95 124.3 178.8 118.7 180.6 113.25 178.85 111.35 176.75 109.05 171.6 107.95 165.3 106.6 160.4 109.25 157.85 110.65 157.7 109.85 157.6 109.3 159.0 106.85 163.3 99.4 163.55 97.1 166.45 99.25 170.7 99.8 175.6 100.45 178.65 98.15 177.9 102.3 178.95 102.65 179.75 102.95 182.65 100.8 192.2 93.85 198.15 92.9 201.55 92.35 199.45 88.85 197.45 85.5 192.5 82.55 187.05 79.25 182.3 79.25 176.55 79.25 173.8 84.3 173.45 80.15 171.6 77.5 169.4 74.45 164.8 72.95"
        />
        <path
          fill="#ffffff"
          d="M134.4 98.1 Q135.75 95.9 137.05 94.55 142.5 96.6 148.9 101.85 L154.2 106.7 152.9 108.5 142.1 107.3 Q133.25 106.45 131.25 107.15 131.65 102.6 134.4 98.1"
        />
        <path
          fill="#ffffff"
          d="M208.8 112.45 L195.65 112.6 184.9 113.0 184.25 111.35 183.9 110.75 190.15 105.85 Q197.5 100.8 203.25 100.1 L205.6 103.95 Q208.05 108.6 208.8 112.45"
        />
        <path
          fill="#0d131a"
          d="M279.9 58.75 Q288.05 52.9 298.15 54.3 308.3 55.75 314.55 63.5 320.8 71.25 319.5 80.85 318.2 90.45 310.1 96.25 301.95 102.1 291.8 100.7 281.7 99.3 275.45 91.55 269.2 83.75 270.5 74.15 271.8 64.55 279.9 58.75"
        />
        <path
          fill="#0d131a"
          d="M86.55 23.8 Q93.55 31.8 92.55 42.05 91.6 52.35 83.3 58.9 74.95 65.5 64.1 64.5 53.25 63.5 46.25 55.5 39.25 47.5 40.2 37.2 41.15 26.9 49.5 20.35 57.85 13.8 68.7 14.8 79.55 15.8 86.55 23.8"
        />
        <path
          fill="#0d131a"
          d="M152.75 105.6 Q152.1 107.2 150.65 108.4 L145.95 107.45 141.25 106.8 Q140.35 105.1 140.35 103.15 140.35 101.9 141.15 100.25 141.85 98.8 142.8 97.8 145.0 98.25 147.95 100.95 L152.75 105.6"
        />
        <path
          fill="#0d131a"
          d="M200.15 108.25 Q200.15 110.85 198.25 112.85 L188.35 112.75 Q187.15 111.85 186.8 110.85 186.45 110.0 186.45 108.25 L190.25 105.65 Q194.45 103.15 196.8 102.55 198.35 103.45 199.25 104.9 200.15 106.45 200.15 108.25"
        />
        <path
          fill="#0d131a"
          d="M43.3 113.4 L44.8 115.3 Q39.55 121.2 34.9 127.4 29.7 134.35 28.75 137.1 L27.05 136.5 Q28.25 132.9 33.05 125.85 38.4 117.95 43.3 113.4"
        />
        <path
          fill="#0d131a"
          d="M227.55 77.6 Q226.0 79.05 225.55 79.7 202.7 67.2 179.4 64.05 156.3 60.9 136.75 67.4 L136.9 65.35 Q156.95 57.65 181.5 61.2 204.95 64.65 227.55 77.6"
        />
        <path
          fill="#0d131a"
          d="M293.5 151.2 Q296.4 158.9 299.25 174.55 L296.2 171.3 Q294.5 162.55 291.1 153.35 L293.5 151.2"
        />
        <path
          fill="#0d131a"
          d="M43.3 74.85 L44.95 77.7 Q32.0 86.15 32.65 89.75 33.35 93.75 42.7 109.5 51.6 124.45 53.75 126.45 L51.0 126.8 Q48.65 124.6 39.75 110.05 30.25 94.5 29.5 90.25 28.6 85.0 43.3 74.85"
        />
        <path
          fill="#0d131a"
          d="M107.3 48.95 L107.3 46.05 Q121.2 43.3 126.25 43.2 131.55 43.1 136.6 60.15 139.15 68.7 140.65 77.45 L138.8 77.65 Q138.3 72.6 134.05 60.5 128.9 45.95 125.2 46.0 118.65 46.1 107.3 48.95"
        />
        <path
          fill="#0d131a"
          d="M44.95 90.6 Q45.15 88.85 52.5 84.45 L53.6 85.95 Q47.25 89.7 46.75 90.9 L46.75 91.05 Q46.75 94.1 54.75 106.85 62.45 119.1 67.3 124.45 L65.95 125.7 Q61.35 120.7 53.4 108.15 44.5 94.05 44.95 90.6"
        />
        <path
          fill="#0d131a"
          d="M121.35 62.2 Q118.65 57.7 117.25 57.85 114.7 58.05 108.4 60.2 L108.4 58.45 Q114.7 56.2 117.1 56.0 119.95 55.7 123.65 62.4 126.4 67.45 128.15 73.05 L125.9 72.1 Q124.05 66.6 121.35 62.2"
        />
        <path
          fill="#0d131a"
          d="M252.85 77.0 L252.35 78.25 251.55 79.35 Q239.4 72.45 234.65 71.3 232.7 70.85 228.85 76.15 225.8 80.4 223.5 85.2 L221.75 84.7 226.85 74.35 Q230.75 67.7 233.75 68.45 235.7 68.95 241.0 71.25 246.65 73.8 252.85 77.0"
        />
        <path
          fill="#0d131a"
          d="M301.15 115.75 Q306.85 122.45 309.75 127.4 313.05 133.1 312.05 135.5 310.75 138.55 299.75 147.9 293.75 153.0 282.75 161.65 L281.1 160.5 Q288.65 154.4 297.3 146.45 307.95 136.55 309.2 133.7 310.0 131.9 307.15 127.35 304.4 123.0 298.8 116.9 L301.15 115.75"
        />
        <path
          fill="#0d131a"
          d="M297.15 131.1 Q296.9 133.8 288.7 142.35 281.9 149.45 274.25 156.0 L272.35 155.2 Q279.25 149.45 286.85 141.6 295.0 133.1 295.3 130.95 294.95 129.45 287.85 123.2 L289.7 122.3 Q297.3 129.25 297.15 131.1"
        />
        <path
          fill="#0d131a"
          d="M247.45 89.0 L246.9 90.8 Q239.15 85.2 237.6 84.7 L236.6 84.85 Q233.6 86.3 228.7 96.4 225.05 103.95 221.9 112.9 L220.15 112.3 Q223.1 104.05 226.25 97.2 231.9 85.05 235.8 83.15 L238.25 82.95 Q239.6 83.45 247.45 89.0"
        />
        <path
          fill="#0d131a"
          d="M224.15 116.0 Q225.8 111.25 229.1 108.2 233.6 104.05 240.5 103.65 L239.6 105.6 Q233.4 106.25 229.6 110.25 226.8 113.25 225.45 117.85 L224.15 116.0"
        />
        <path
          fill="#0d131a"
          d="M277.95 133.25 Q278.4 138.05 277.0 142.4 274.75 149.4 268.1 152.85 L266.8 151.45 Q272.95 148.45 275.15 142.3 276.6 138.2 276.15 133.4 L275.75 131.65 277.35 130.65 Q277.85 132.05 277.95 133.25"
        />
        <path
          fill="#0d131a"
          d="M231.75 124.7 L229.95 122.65 Q229.05 117.9 232.7 114.25 235.75 111.2 239.85 110.5 L239.85 112.5 Q235.1 114.25 233.05 118.55 231.65 121.45 231.75 124.7"
        />
        <path
          fill="#0d131a"
          d="M270.45 134.1 Q270.85 140.55 267.65 143.85 266.15 145.5 263.35 146.45 L258.1 147.6 256.5 145.85 Q259.2 145.75 261.7 144.65 264.25 143.6 265.95 141.8 268.85 138.6 268.6 134.4 L270.45 134.1"
        />
        <path
          fill="#0d131a"
          d="M329.45 65.6 Q332.1 72.55 331.8 79.0 331.4 86.85 328.3 93.35 324.95 100.45 318.55 105.4 311.35 111.0 295.3 121.0 L275.2 133.0 Q269.65 136.1 262.9 135.85 255.7 135.6 248.85 131.65 242.4 127.9 239.75 119.5 237.4 111.95 239.35 106.15 241.45 99.9 249.65 80.95 258.35 60.8 260.75 57.4 265.3 50.35 272.7 46.05 280.0 41.75 288.9 40.9 296.9 40.1 305.4 42.9 313.75 45.65 319.35 50.85 326.2 57.15 329.45 65.6 M325.4 92.65 Q328.6 86.15 328.95 79.05 329.3 72.65 327.15 66.65 324.3 58.75 317.45 52.3 312.3 47.45 304.25 45.1 296.3 42.8 288.5 43.75 279.65 44.85 273.15 49.3 267.8 52.95 263.05 59.65 260.55 63.15 251.65 82.35 242.95 101.2 241.1 106.75 239.35 112.05 241.35 118.6 243.7 126.1 249.85 129.45 256.6 133.1 263.0 133.6 269.4 134.1 274.3 131.35 280.0 128.2 294.1 119.0 309.45 108.9 317.15 103.05 322.2 99.2 325.4 92.65"
        />
        <path
          fill="#0d131a"
          d="M279.8 59.7 Q276.25 62.35 274.05 66.1 271.85 69.85 271.3 74.1 270.7 78.35 271.8 82.55 272.95 86.7 275.6 90.25 278.55 94.1 282.7 96.5 286.9 98.95 291.85 99.6 L301.45 99.1 Q306.15 97.85 309.95 94.95 313.5 92.25 315.7 88.55 317.9 84.8 318.5 80.55 319.75 71.35 313.7 63.85 307.7 56.4 297.95 55.05 293.0 54.4 288.35 55.6 283.65 56.75 279.8 59.7 M272.5 65.15 Q274.85 61.15 278.7 58.2 282.85 55.1 287.85 53.8 292.9 52.5 298.2 53.2 308.7 54.65 315.2 62.75 321.7 70.85 320.3 80.8 319.65 85.45 317.3 89.5 314.9 93.5 311.1 96.4 306.95 99.55 301.9 100.85 296.85 102.15 291.6 101.4 286.3 100.7 281.8 98.1 277.3 95.5 274.15 91.35 271.25 87.5 270.05 83.0 268.8 78.5 269.45 73.85 270.1 69.2 272.5 65.15"
        />
        <path
          fill="#0d131a"
          d="M74.3 124.7 Q64.9 119.05 65.3 108.8 65.4 105.6 66.5 102.25 L67.6 99.3 69.05 101.3 Q67.55 108.05 68.55 112.9 70.0 119.8 76.55 124.05 L74.3 124.7"
        />
        <path
          fill="#0d131a"
          d="M117.05 76.25 L117.05 78.2 Q113.65 77.15 110.8 76.65 L110.7 74.75 117.05 76.25"
        />
        <path
          fill="#0d131a"
          d="M112.95 90.3 Q112.0 88.15 110.1 86.15 L110.45 84.0 Q113.25 86.35 114.65 89.55 116.35 93.5 115.75 98.05 113.65 100.5 112.7 100.75 114.45 93.75 112.95 90.3"
        />
        <path
          fill="#0d131a"
          d="M74.7 108.45 Q73.55 106.4 72.85 103.9 L73.9 104.05 74.9 104.3 Q75.25 105.4 76.05 106.9 78.1 110.35 81.5 112.85 84.95 115.3 88.35 115.75 91.45 116.15 94.6 115.7 L92.3 117.45 Q90.4 118.65 89.5 118.5 79.75 117.2 74.7 108.45"
        />
        <path
          fill="#0d131a"
          d="M94.25 11.85 Q101.75 19.15 104.35 26.65 106.25 32.3 109.1 53.15 112.0 74.65 111.7 82.9 111.45 90.3 107.7 96.35 103.4 103.35 96.0 105.4 87.5 107.75 80.2 106.55 73.05 105.35 68.35 101.05 60.95 94.35 51.6 85.05 39.2 72.7 33.3 65.35 27.9 58.7 26.05 51.05 24.1 43.0 25.9 33.05 27.25 25.55 31.0 19.1 36.0 10.5 44.5 5.5 51.75 1.3 61.05 0.3 70.1 -0.7 78.1 1.7 86.45 4.2 94.25 11.85 M102.3 28.45 Q99.75 20.35 91.95 13.4 84.6 6.8 76.05 4.2 68.45 1.9 60.8 2.9 53.15 3.85 46.05 8.0 37.9 12.75 33.3 20.25 29.8 25.95 28.6 32.8 26.95 41.95 29.3 51.25 31.4 59.4 35.55 64.45 41.7 71.9 53.4 83.9 63.3 94.0 69.55 99.7 73.85 103.6 80.5 104.5 87.15 105.4 95.3 103.15 102.1 101.3 106.1 95.05 109.65 89.55 109.85 82.8 L109.9 81.5 Q109.9 71.55 107.3 53.75 104.8 36.3 102.3 28.45"
        />
        <path
          fill="#0d131a"
          d="M87.1 23.0 Q94.35 31.3 93.35 41.95 92.9 46.95 90.55 51.35 88.2 55.75 84.25 59.0 80.05 62.5 74.8 64.15 69.55 65.75 63.9 65.2 52.7 64.15 45.45 55.9 38.2 47.6 39.15 36.95 39.65 31.95 42.0 27.55 44.3 23.15 48.25 19.85 52.5 16.35 57.75 14.75 63.05 13.2 68.65 13.7 79.85 14.7 87.1 23.0 M91.5 41.8 Q92.45 31.9 85.7 24.2 78.95 16.5 68.5 15.55 63.2 15.05 58.3 16.5 53.4 18.0 49.45 21.3 45.8 24.35 43.6 28.4 41.45 32.45 41.0 37.1 40.1 47.0 46.85 54.7 53.6 62.4 64.05 63.35 69.3 63.85 74.2 62.35 79.1 60.85 83.1 57.6 86.75 54.55 88.9 50.5 91.1 46.4 91.5 41.8"
        />
        <path
          fill="#0d131a"
          d="M178.3 353.9 L178.25 355.35 Q172.1 359.35 170.25 362.25 L169.85 363.2 Q170.4 363.85 173.75 364.85 177.15 365.85 181.5 366.65 L183.1 369.4 Q168.35 367.05 166.95 365.25 166.25 364.45 166.75 363.15 167.35 361.45 171.15 358.0 174.85 354.65 178.4 352.45 L178.3 353.9"
        />
        <path
          fill="#0d131a"
          d="M117.55 95.5 L118.5 97.9 Q111.95 102.8 105.45 109.15 95.4 119.0 85.15 122.55 78.65 124.85 66.4 125.75 L60.2 126.25 Q43.05 127.9 29.1 138.35 16.65 147.6 12.4 158.85 9.45 166.7 11.2 176.4 12.7 184.7 17.35 192.95 17.75 195.5 18.75 199.15 11.75 189.5 9.25 180.75 5.75 168.7 10.0 157.1 14.9 143.65 27.95 134.9 41.35 125.9 60.0 124.1 L66.25 123.6 Q78.1 122.7 83.85 120.65 93.2 117.35 102.9 107.9 110.2 100.75 117.55 95.5"
        />
        <path
          fill="#0d131a"
          d="M239.95 134.75 Q232.4 127.6 221.5 114.9 L220.85 114.1 219.75 109.55 223.15 113.5 Q233.9 126.05 241.35 133.1 252.3 143.5 262.25 148.45 290.25 162.45 300.5 173.75 315.7 190.5 305.35 210.9 L304.0 208.4 Q311.1 190.85 297.1 175.05 286.3 162.9 261.25 150.35 251.1 145.3 239.95 134.75"
        />
        <path
          fill="#0d131a"
          d="M189.05 372.3 L191.15 373.55 Q191.35 375.2 192.1 376.9 189.3 375.55 186.8 373.95 179.85 369.5 177.9 360.95 176.3 353.85 178.45 350.4 L180.5 349.6 Q178.75 352.4 180.45 359.5 182.5 368.1 189.05 372.3"
        />
        <path
          fill="#0d131a"
          d="M228.95 382.45 L220.25 382.9 221.55 380.3 227.0 379.95 228.95 382.45"
        />
        <path
          fill="#0d131a"
          d="M266.55 351.5 Q268.55 356.05 265.7 361.55 263.15 366.35 257.35 371.05 L254.75 369.8 Q260.0 365.5 262.6 360.85 265.4 355.85 264.2 352.0 L266.55 351.5"
        />
        <path
          fill="#0d131a"
          d="M18.7 224.95 L20.6 227.1 Q19.35 238.2 20.25 250.75 21.8 270.75 28.9 284.55 L26.85 286.7 Q17.9 272.1 16.9 251.0 16.25 237.7 18.7 224.95"
        />
        <path
          fill="#0d131a"
          d="M270.3 277.2 Q277.2 285.45 280.7 293.7 286.65 307.7 284.35 323.3 281.95 339.65 274.75 347.45 271.2 351.3 263.4 354.6 L262.95 354.8 Q249.85 360.4 236.55 360.4 213.65 360.3 195.5 343.35 L198.35 341.85 Q214.6 355.95 236.45 356.85 251.35 357.45 262.1 352.8 L262.55 352.6 Q269.05 349.85 272.55 345.55 278.7 338.0 281.0 322.25 284.6 297.8 268.9 278.9 L270.3 277.2"
        />
        <path
          fill="#0d131a"
          d="M194.15 386.45 Q188.85 377.65 189.85 373.9 190.5 371.5 195.0 369.25 200.2 366.65 206.1 367.25 214.6 368.1 219.5 373.75 223.6 378.45 222.45 381.6 221.05 385.3 213.4 390.4 206.35 395.05 203.65 395.25 199.6 395.55 194.15 386.45 M192.95 373.75 Q191.8 374.65 194.65 380.3 197.35 385.8 200.55 389.45 203.05 392.3 203.9 392.3 205.9 392.2 212.25 388.0 219.2 383.35 220.4 380.15 221.1 378.25 217.35 375.05 213.15 371.45 206.95 370.1 199.7 368.55 192.95 373.75"
        />
        <path
          fill="#0d131a"
          d="M225.25 378.95 Q225.4 376.45 228.65 373.75 231.9 371.1 236.7 369.4 248.45 365.25 256.85 369.95 260.95 372.2 265.3 381.9 269.6 391.35 269.15 396.5 268.9 399.55 266.85 400.0 262.1 400.95 249.8 396.25 237.6 391.6 230.25 386.15 225.05 382.25 225.25 378.95 M235.9 371.6 Q232.15 373.1 229.7 375.35 227.4 377.4 227.4 379.05 227.4 383.3 243.25 390.55 259.1 397.8 265.4 396.55 266.05 396.45 266.2 394.7 266.6 389.85 262.9 381.45 259.15 372.8 255.7 371.5 245.6 367.7 235.9 371.6"
        />
        <path
          fill="#0d131a"
          d="M201.25 170.95 Q186.9 176.45 170.55 176.7 155.6 176.95 139.4 170.4 126.25 165.05 119.9 159.05 L112.6 151.65 Q107.4 146.15 104.85 143.95 100.8 140.45 98.3 140.1 96.25 139.8 93.0 142.25 89.95 144.6 86.85 149.4 84.15 153.6 83.95 155.2 L82.3 153.55 Q82.55 151.4 85.15 147.3 88.0 142.75 91.15 140.3 92.9 139.0 95.1 138.45 L98.55 138.25 Q101.5 138.65 105.7 142.25 108.25 144.4 113.95 150.4 L121.15 157.7 Q127.4 163.55 140.15 168.7 155.95 175.1 170.55 174.85 186.45 174.6 200.45 169.25 214.45 163.95 221.4 155.55 223.0 153.6 225.2 152.55 227.6 151.4 230.1 151.6 233.8 151.95 237.2 154.1 240.7 156.3 242.45 159.45 244.65 163.3 245.25 172.45 245.7 179.75 245.05 186.9 L243.55 188.75 Q242.65 189.7 242.8 188.35 L242.85 187.65 Q243.65 181.05 243.25 173.9 242.8 165.15 240.6 161.2 239.05 158.45 235.85 156.4 232.7 154.35 229.55 154.1 225.35 153.65 222.8 156.7 215.7 165.45 201.25 170.95"
        />
        <path
          fill="#0d131a"
          d="M118.05 349.55 L117.85 347.9 117.55 346.25 Q143.1 355.0 173.1 348.7 190.9 345.0 205.1 337.65 217.3 331.35 228.8 317.7 234.65 312.5 240.55 302.45 246.25 292.65 246.05 288.75 L248.05 288.15 Q248.8 293.35 242.95 303.55 237.35 313.35 231.2 318.6 225.5 328.55 212.35 336.95 199.65 345.1 183.2 349.9 166.3 354.85 149.7 354.95 131.9 355.1 118.05 349.55"
        />
        <path
          fill="#0d131a"
          d="M214.6 167.25 L228.05 157.05 Q233.9 153.55 238.25 156.45 L238.65 157.8 Q234.75 155.2 229.75 158.2 L215.0 169.3 Q205.5 176.3 189.6 180.0 172.25 184.0 157.4 181.4 138.85 178.15 123.9 167.8 115.25 161.85 105.35 151.05 L102.75 147.9 Q99.05 144.0 94.8 143.8 91.7 143.6 88.65 145.35 L89.85 143.6 Q93.4 142.2 95.8 142.35 99.6 142.6 103.0 146.15 L105.65 149.4 Q115.35 160.0 124.15 166.05 139.1 176.3 157.45 179.45 171.6 181.9 188.35 178.25 204.75 174.65 214.6 167.25"
        />
        <path
          fill="#0d131a"
          d="M132.05 330.8 Q144.75 333.65 159.4 334.35 199.75 336.3 225.75 321.35 L226.55 322.7 221.85 325.2 Q195.65 338.85 157.1 336.3 143.0 335.4 131.0 332.5 120.4 329.95 117.7 327.6 L118.1 325.85 Q120.85 328.25 132.05 330.8"
        />
        <path
          fill="#0d131a"
          d="M160.8 332.85 Q145.65 331.9 132.6 328.75 121.0 325.95 118.1 323.4 L119.1 322.2 Q121.45 324.25 133.75 326.8 147.85 329.7 163.5 330.5 207.6 332.65 230.65 316.4 L228.45 320.4 Q202.25 335.5 160.8 332.85"
        />
        <path
          fill="#0d131a"
          d="M95.35 266.75 Q104.9 274.35 119.5 280.4 135.35 287.0 153.1 289.9 196.2 297.05 232.4 280.85 L231.65 281.9 231.0 283.0 Q193.1 299.9 147.75 290.7 129.4 287.0 113.5 279.45 98.8 272.5 90.45 264.45 L92.9 265.75 95.35 266.75"
        />
        <path
          fill="#0d131a"
          d="M115.95 275.7 Q103.65 270.15 97.5 265.05 L98.5 263.85 Q104.3 268.65 116.4 273.85 130.75 280.05 147.25 283.65 185.35 291.85 216.9 282.2 L219.3 283.05 Q200.55 289.7 179.7 289.7 164.5 289.7 147.45 286.05 131.0 282.5 115.95 275.7"
        />
        <path
          fill="#0d131a"
          d="M87.45 208.9 L88.5 207.8 Q96.15 214.8 109.15 221.3 124.35 228.85 141.05 232.45 181.8 241.3 228.45 221.7 L228.45 223.55 Q203.7 234.1 182.85 236.7 161.9 239.35 140.15 234.65 123.5 231.0 108.15 222.95 95.65 216.4 87.45 208.9"
        />
        <path
          fill="#0d131a"
          d="M89.35 203.5 L90.45 202.45 Q96.75 208.95 109.7 215.45 125.05 223.2 142.55 226.95 189.45 237.1 229.75 215.0 L229.55 217.15 Q205.55 229.75 179.3 231.8 159.2 233.35 139.25 228.65 122.05 224.6 107.2 216.4 95.55 209.95 89.35 203.5"
        />
        <path
          fill="#0d131a"
          d="M14.45 324.3 L16.6 324.75 Q12.8 343.95 14.05 358.45 15.35 372.95 21.7 381.8 L20.5 383.85 Q12.65 374.95 10.95 359.95 9.15 344.2 14.45 324.3"
        />
        <path
          fill="#0d131a"
          d="M78.8 395.3 L79.75 393.0 82.1 392.25 Q83.65 391.55 84.4 391.4 L85.6 392.75 86.9 394.0 78.8 395.3"
        />
        <path
          fill="#0d131a"
          d="M116.55 321.85 Q117.55 319.6 117.85 316.95 121.3 330.3 119.2 348.15 117.25 365.0 111.55 376.85 L109.05 374.75 Q113.6 364.1 115.8 349.2 118.1 333.6 116.55 321.85"
        />
        <path
          fill="#0d131a"
          d="M84.7 394.0 Q83.25 392.8 82.95 390.55 82.6 387.95 84.05 385.05 87.1 379.0 93.55 375.65 101.1 371.75 110.0 373.9 111.7 374.3 113.2 377.9 114.3 380.6 114.85 383.75 115.8 389.45 115.6 393.75 115.4 399.5 113.2 400.9 109.6 403.2 99.75 400.8 90.0 398.4 84.7 394.0 M95.0 376.95 Q89.65 379.65 86.9 385.1 85.35 388.25 85.35 390.7 85.35 392.15 85.9 392.6 90.7 396.65 99.7 398.4 108.3 400.1 111.35 398.15 112.75 397.25 113.1 392.95 113.4 388.7 112.55 383.3 111.95 379.75 111.0 377.6 110.2 375.85 109.55 375.7 101.35 373.75 95.0 376.95"
        />
        <path
          fill="#0d131a"
          d="M19.8 384.15 Q20.95 377.85 30.05 376.15 36.55 374.95 49.45 375.95 61.55 376.9 71.75 381.9 82.45 387.15 82.1 392.75 82.05 394.5 79.8 396.5 73.95 401.75 57.5 406.35 40.4 411.1 28.15 410.35 26.7 410.25 25.15 409.35 23.45 408.4 22.7 407.1 20.05 402.6 19.3 396.3 18.65 390.35 19.8 384.15 M30.55 378.25 Q23.3 379.35 22.4 384.2 21.35 389.95 22.2 395.8 23.1 401.7 25.6 404.85 27.1 406.7 29.05 406.85 41.05 407.55 56.9 403.55 72.45 399.6 77.85 394.75 79.5 393.3 79.55 392.3 79.8 388.0 70.35 383.7 60.9 379.4 49.2 378.5 35.7 377.5 30.55 378.25"
        />
        <path
          fill="#0d131a"
          d="M48.15 273.55 Q53.7 272.45 60.35 272.35 L60.3 274.5 Q52.85 274.65 46.35 276.45 L48.15 273.55"
        />
        <path
          fill="#0d131a"
          d="M40.7 275.6 L42.65 277.7 Q29.7 282.6 22.45 294.55 16.95 303.5 16.45 312.2 15.4 328.75 20.2 339.65 26.55 354.0 42.55 357.2 52.35 359.15 62.55 360.0 76.0 361.1 81.85 359.2 96.35 354.5 106.35 340.85 115.7 328.0 115.2 316.05 114.5 300.0 105.0 288.55 94.2 275.5 75.6 273.75 L75.75 271.6 Q96.1 273.4 107.75 287.1 117.85 299.05 118.6 316.0 119.15 328.6 109.1 342.5 98.45 357.3 83.3 362.2 77.25 364.15 62.55 362.75 51.9 361.75 41.2 359.6 26.1 356.6 18.85 345.1 11.45 333.3 12.7 313.3 13.3 303.55 18.75 294.05 26.4 280.75 40.7 275.6"
        />
        <path
          fill="#0d131a"
          d="M63.95 144.15 Q71.4 144.1 77.05 146.8 82.65 149.55 85.9 154.7 90.25 161.75 90.15 171.1 90.05 179.35 87.0 183.95 L85.1 183.0 Q87.35 178.4 87.35 170.95 87.35 162.1 83.5 156.0 80.65 151.4 75.3 149.1 70.1 146.85 63.1 146.9 50.15 147.0 39.8 152.55 29.45 158.1 23.3 168.3 19.1 175.25 18.15 182.85 17.2 190.4 19.65 197.25 18.8 198.15 18.15 199.4 14.95 191.65 15.45 183.5 15.95 174.85 20.5 167.25 26.9 156.65 38.7 150.45 50.35 144.3 63.95 144.15"
        />
        <path
          fill="#0d131a"
          d="M19.05 195.85 Q24.1 186.35 38.9 178.8 55.15 170.5 68.85 172.95 76.1 174.25 81.7 178.45 87.25 182.6 89.9 188.6 92.05 193.5 91.55 199.05 91.1 204.3 88.5 208.55 L86.65 207.4 Q88.9 203.75 89.05 198.8 89.2 193.85 87.2 189.25 84.8 183.75 79.95 180.1 75.15 176.45 68.45 175.05 56.3 172.6 40.7 180.55 26.3 187.9 21.55 196.8 18.7 202.2 17.7 208.1 16.55 215.15 18.55 220.75 20.35 225.75 24.5 229.15 23.85 229.9 23.6 231.15 20.75 228.95 19.05 227.05 16.9 224.6 15.95 221.9 13.95 216.3 14.8 209.35 15.6 202.3 19.05 195.85"
        />
        <path
          fill="#0d131a"
          d="M38.15 274.4 Q36.3 271.05 31.95 260.2 L30.25 256.1 Q31.3 257.3 33.1 258.1 L33.65 259.5 Q40.8 277.3 43.85 276.35 46.0 275.7 48.2 271.15 49.8 267.8 51.0 263.35 L53.3 263.4 Q51.9 268.5 50.1 272.45 47.25 278.75 44.35 279.6 41.5 280.5 38.15 274.4"
        />
        <path
          fill="#0d131a"
          d="M95.25 238.4 Q95.7 236.05 96.1 235.35 101.05 241.9 101.3 252.1 101.45 258.6 99.75 265.55 98.9 269.0 97.65 269.3 94.75 270.3 79.45 257.45 L81.5 256.15 Q84.6 258.7 89.7 262.1 95.65 266.15 97.0 266.1 97.45 265.7 98.0 263.45 98.65 260.75 98.85 257.05 L98.95 254.4 Q98.95 244.0 95.25 238.4"
        />
        <path
          fill="#0d131a"
          d="M77.3 259.3 L79.85 258.15 Q79.65 263.2 77.55 271.0 75.25 279.7 72.85 282.1 71.7 283.25 70.45 283.05 67.0 282.4 62.0 276.85 57.0 271.2 53.5 263.95 L55.85 264.5 Q59.1 270.85 63.7 275.45 67.9 279.6 70.75 280.15 71.05 280.2 71.55 279.7 73.45 277.75 75.3 270.6 76.95 264.2 77.3 259.3"
        />
        <path
          fill="#0d131a"
          d="M91.5 211.0 Q96.2 215.6 97.6 220.4 99.05 225.45 97.8 232.05 96.5 238.7 92.85 245.05 88.75 252.15 82.8 256.95 76.9 261.75 70.2 263.4 60.1 265.9 50.0 264.75 39.65 263.55 32.7 258.85 28.75 256.2 26.1 252.05 23.45 247.95 22.9 243.75 21.2 231.8 25.95 222.3 30.65 212.7 41.25 206.8 50.55 201.65 60.6 200.75 70.9 199.9 80.25 203.7 86.65 206.3 91.5 211.0 M90.45 244.5 Q94.0 238.35 95.4 232.05 96.85 225.55 95.5 221.0 94.25 216.8 90.05 212.9 85.85 209.0 79.8 206.55 70.8 202.9 61.1 203.55 51.4 204.2 42.7 209.05 32.65 214.65 28.15 223.65 23.65 232.65 25.2 243.85 26.25 251.4 33.6 256.4 40.3 260.95 49.3 262.25 58.4 263.55 67.85 261.25 74.5 259.6 80.35 255.45 86.7 250.9 90.45 244.5"
        />
        <path
          fill="#0d131a"
          d="M244.25 187.45 Q252.45 180.1 265.3 179.05 278.75 177.95 289.5 184.75 301.8 192.5 306.0 208.25 309.65 221.8 304.75 232.8 300.5 242.25 291.75 246.8 L290.75 244.9 Q297.95 241.15 301.7 233.55 306.85 223.3 303.1 209.35 299.25 194.95 288.55 187.35 279.15 180.65 267.2 180.9 255.8 181.1 247.85 187.25 239.4 193.8 239.3 203.9 239.3 204.6 237.35 206.25 235.55 195.3 244.25 187.45"
        />
        <path
          fill="#0d131a"
          d="M290.35 231.9 Q292.4 238.85 292.0 245.3 291.65 251.45 289.1 255.95 286.8 260.0 283.1 262.6 278.95 265.5 273.55 266.15 L273.55 263.9 Q283.3 260.65 286.95 254.05 291.55 246.0 287.55 232.65 283.85 219.95 273.9 210.8 262.2 200.0 248.65 202.15 238.25 203.8 233.3 211.85 230.65 216.1 229.95 221.5 229.35 226.1 230.25 229.1 L228.2 229.7 Q227.05 226.05 227.25 221.55 227.5 215.35 230.45 210.6 233.05 206.4 237.95 203.6 242.55 200.95 248.3 200.05 262.8 197.75 275.5 209.0 286.45 218.65 290.35 231.9"
        />
        <path
          fill="#0d131a"
          d="M219.0 241.55 L219.85 244.3 Q215.75 248.0 212.05 256.4 208.55 264.4 209.85 265.4 L216.2 265.05 221.3 263.65 221.75 265.1 216.15 266.6 Q210.35 267.95 208.05 267.45 207.1 267.3 206.8 266.2 206.1 263.3 211.35 253.35 216.3 243.95 219.0 241.55"
        />
        <path
          fill="#0d131a"
          d="M248.2 287.05 L250.55 287.35 252.85 287.65 Q243.95 290.25 237.4 291.35 230.45 292.45 229.35 291.25 228.4 290.2 229.6 286.05 230.65 282.35 232.2 279.65 L233.5 280.45 Q231.9 283.25 231.0 286.15 230.0 289.25 230.7 289.9 L236.9 289.6 Q242.15 288.7 248.2 287.05"
        />
        <path
          fill="#0d131a"
          d="M220.3 264.65 L221.25 266.05 Q218.25 270.5 216.55 274.35 214.25 279.55 215.6 281.55 216.25 282.35 221.3 282.0 226.8 281.6 232.5 280.05 232.8 280.75 233.85 281.25 227.35 283.15 221.35 283.95 214.2 284.85 213.15 283.25 210.3 279.05 220.3 264.65"
        />
        <path
          fill="#0d131a"
          d="M246.05 226.75 Q253.8 228.8 260.05 234.25 266.55 239.85 270.3 248.1 276.0 260.6 274.15 270.75 272.4 280.25 264.85 284.55 255.3 290.0 247.5 288.9 238.75 287.65 227.9 277.8 222.55 272.95 219.6 265.85 216.8 259.05 216.8 251.5 L216.8 250.15 Q217.0 235.3 226.05 229.15 234.15 223.6 246.05 226.75 M258.7 235.9 Q252.75 230.7 245.55 228.85 237.7 226.85 229.7 231.65 220.0 237.45 219.15 250.1 218.8 255.75 220.7 261.4 223.3 269.2 229.75 275.05 240.45 284.75 248.7 285.6 254.75 286.25 263.55 281.65 270.9 277.85 272.2 268.95 273.5 260.05 268.35 249.0 264.65 241.15 258.7 235.9"
        />
        <path
          fill="#0d131a"
          d="M175.55 78.5 L174.55 83.4 Q174.0 86.05 173.65 85.85 172.8 85.35 173.65 79.45 174.0 77.3 172.95 76.15 172.3 75.4 170.5 74.7 165.6 72.9 154.55 74.45 144.4 75.9 139.45 78.4 137.55 79.35 137.2 79.0 136.85 78.6 138.4 77.45 134.95 75.35 127.85 74.05 L119.9 73.7 Q117.3 76.0 117.3 82.75 117.3 88.25 118.3 93.1 119.1 97.05 120.3 99.55 122.05 98.3 122.25 98.7 122.45 99.1 121.45 100.65 120.05 102.85 118.2 107.4 115.75 113.35 115.2 117.35 114.7 120.7 114.75 122.7 L115.05 126.8 114.6 128.2 Q114.25 129.1 114.0 128.95 113.6 128.0 113.15 125.65 112.6 123.05 112.6 121.6 112.6 116.05 114.3 110.2 116.1 103.95 118.95 100.6 117.6 97.15 116.6 93.9 114.7 87.65 114.7 82.9 114.7 74.95 118.0 72.0 119.85 70.4 126.75 71.65 134.1 72.95 139.4 76.35 146.5 73.05 156.0 71.95 165.7 70.8 171.15 72.85 173.25 73.6 174.9 75.9 178.7 71.6 190.8 75.65 200.35 78.85 205.2 82.55 L218.7 82.95 Q224.2 83.9 226.15 85.75 226.95 86.55 226.95 88.75 226.95 92.45 224.95 98.3 223.05 103.95 220.4 108.55 224.2 118.45 222.75 128.5 221.7 135.55 220.05 137.2 219.4 137.9 218.4 137.0 217.4 136.1 218.1 134.55 219.35 131.95 220.0 125.5 220.8 117.15 219.0 110.45 217.7 111.05 217.65 110.2 217.6 109.4 218.4 108.55 219.3 107.5 222.3 99.7 225.5 91.3 225.5 88.65 225.5 87.3 225.05 86.85 223.7 85.5 217.3 84.85 210.85 84.15 205.05 84.8 203.3 85.0 202.2 84.4 201.0 83.75 203.3 83.05 202.7 82.4 198.7 80.75 194.2 78.85 189.65 77.6 176.85 74.05 175.55 78.5"
        />
        <path
          fill="#0d131a"
          d="M133.25 81.95 L125.0 92.95 Q124.25 89.9 123.65 86.65 122.45 80.2 123.4 79.4 125.1 77.95 133.25 81.95"
        />
        <path
          fill="#0d131a"
          d="M123.75 79.8 Q123.5 80.05 123.5 81.05 123.5 84.05 125.25 91.7 L132.45 82.2 Q125.1 78.6 123.75 79.8 M133.5 81.5 Q134.6 82.2 133.65 82.75 133.05 83.15 129.85 87.35 L125.85 92.7 Q125.1 93.75 124.75 93.5 L124.5 93.05 Q121.3 80.5 123.05 79.0 125.05 77.25 133.5 81.5"
        />
        <path
          fill="#0d131a"
          d="M219.25 89.3 Q219.25 90.95 216.55 99.45 L208.55 89.3 214.6 88.5 Q219.2 88.2 219.25 89.3"
        />
        <path
          fill="#0d131a"
          d="M209.25 88.5 Q217.6 87.15 219.35 88.45 L219.8 89.3 Q219.8 90.55 218.7 94.7 217.6 98.8 217.05 99.6 216.6 100.3 216.2 100.15 L215.4 99.4 Q209.5 91.05 208.65 90.25 207.1 88.8 209.25 88.5 M218.7 89.35 L214.9 89.0 209.5 89.65 216.3 98.3 Q218.7 90.65 218.7 89.35"
        />
        <path
          fill="#0d131a"
          d="M163.45 94.95 Q163.6 93.6 163.95 94.1 164.3 94.6 164.25 96.25 164.15 98.85 163.05 102.05 161.95 105.45 160.75 106.15 159.6 106.85 159.4 106.35 159.2 105.9 159.95 104.85 160.65 103.8 162.0 100.05 163.3 96.3 163.45 94.95"
        />
        <path
          fill="#0d131a"
          d="M177.8 98.4 Q177.65 95.9 178.15 95.5 178.65 95.1 178.95 97.75 179.55 103.25 181.0 106.45 181.85 108.3 181.7 108.85 181.5 109.4 180.15 108.2 178.9 107.1 178.35 103.9 L177.8 98.4"
        />
        <path
          fill="#0d131a"
          d="M163.15 107.4 Q166.3 106.15 168.7 106.3 174.8 106.7 178.45 110.25 179.65 111.4 179.4 111.8 179.2 112.15 178.2 111.35 177.25 110.55 174.5 109.65 171.5 108.65 169.05 108.45 L164.4 108.7 Q162.3 109.05 160.85 109.65 L159.35 110.05 Q159.05 109.95 159.7 109.35 160.55 108.5 163.15 107.4"
        />
        <path
          fill="#0d131a"
          d="M148.1 117.45 Q146.55 116.75 146.45 115.7 146.35 114.6 148.3 114.6 150.3 114.6 152.85 117.25 155.15 119.6 155.9 121.7 156.45 123.35 155.75 123.4 155.15 123.4 154.5 122.4 152.65 119.5 148.1 117.45"
        />
        <path
          fill="#0d131a"
          d="M169.5 121.05 Q175.4 121.85 178.8 125.25 180.05 126.5 180.0 127.15 179.95 127.75 178.5 126.7 174.15 123.35 168.1 122.95 162.45 122.55 157.65 124.7 L156.05 124.8 Q155.9 124.25 157.3 123.4 162.95 120.15 169.5 121.05"
        />
        <path
          fill="#0d131a"
          d="M180.5 124.5 Q181.9 122.45 184.85 120.85 188.1 119.1 190.3 119.6 190.9 119.75 191.15 120.95 191.35 122.2 190.45 122.2 188.85 122.2 186.4 122.95 183.15 123.9 181.6 125.6 180.6 126.7 180.25 126.1 179.85 125.5 180.5 124.5"
        />
        <path
          fill="#0d131a"
          d="M152.95 108.2 L153.55 106.9 147.8 101.8 Q142.05 97.2 137.2 95.3 135.8 96.95 134.6 99.05 132.65 102.55 132.15 106.2 L142.45 106.75 149.4 107.75 152.95 108.2 M133.15 98.45 Q133.7 97.45 136.1 94.95 134.4 94.1 134.1 93.25 133.8 92.3 136.95 93.4 142.05 95.2 147.6 99.5 152.35 103.2 154.3 106.05 155.35 107.65 155.0 107.7 L154.4 107.45 153.85 108.4 154.3 108.9 Q154.35 109.4 152.45 109.25 L142.5 108.3 131.45 107.75 Q128.6 107.95 128.55 107.35 128.45 106.75 130.9 106.2 131.35 101.4 133.15 98.45"
        />
        <path
          fill="#0d131a"
          d="M203.2 99.5 Q206.85 98.9 206.85 99.75 206.8 100.55 204.45 100.9 206.05 101.95 207.45 104.8 209.2 108.2 209.05 111.6 210.85 111.9 210.9 112.5 210.95 113.05 208.85 113.05 L196.75 113.2 185.05 113.6 Q183.6 113.8 183.85 113.25 L184.4 112.7 Q183.9 112.05 183.75 111.45 L182.85 111.5 Q182.55 111.25 183.45 110.3 186.15 107.5 191.5 104.3 198.1 100.35 203.2 99.5 M207.8 111.65 Q207.45 108.9 205.85 105.65 204.5 102.85 203.0 101.25 197.95 102.0 191.55 105.9 187.45 108.4 184.65 110.9 L185.3 112.35 197.5 111.8 207.8 111.65"
        />
        <path
          fill="#0d131a"
          d="M142.6 97.45 L143.5 98.15 Q140.9 99.95 140.9 103.15 140.9 105.55 142.45 107.2 L140.85 106.95 Q139.8 105.15 139.8 103.15 139.8 99.6 142.6 97.45"
        />
        <path
          fill="#0d131a"
          d="M152.3 105.15 L153.15 106.05 Q152.5 107.5 151.4 108.45 L150.1 108.1 Q151.7 107.0 152.3 105.15"
        />
        <path
          fill="#0d131a"
          d="M187.0 108.25 Q187.0 111.2 189.4 113.0 L187.9 113.1 Q186.1 111.25 185.95 108.55 L187.1 107.45 187.0 108.25"
        />
        <path
          fill="#0d131a"
          d="M200.7 108.25 Q200.7 110.8 199.0 112.8 L197.45 112.8 Q199.25 111.3 199.25 108.2 199.25 104.4 196.2 102.85 L197.5 102.35 Q198.95 103.35 199.8 104.85 200.7 106.45 200.7 108.25"
        />
        <path
          fill="#0d131a"
          d="M193.4 107.95 Q193.4 109.4 192.95 110.35 192.5 111.35 191.8 111.35 191.15 111.35 190.7 110.35 190.25 109.35 190.25 107.95 190.25 106.55 190.7 105.6 191.15 104.6 191.8 104.6 192.45 104.6 192.95 105.6 193.4 106.55 193.4 107.95"
        />
        <path
          fill="#0d131a"
          d="M150.2 104.05 Q150.2 105.3 149.7 106.25 149.25 107.15 148.55 107.15 147.9 107.15 147.4 106.25 146.95 105.35 146.95 104.05 146.95 102.75 147.4 101.85 147.9 100.95 148.55 100.95 149.25 100.95 149.7 101.85 150.2 102.75 150.2 104.05"
        />
        <path
          fill="#ffffff"
          d="M197.8 105.9 Q197.8 107.5 196.3 107.5 195.65 107.5 195.25 107.1 194.8 106.65 194.8 105.9 194.8 105.15 195.25 104.7 195.65 104.2 196.25 104.2 196.9 104.2 197.35 104.7 197.8 105.15 197.8 105.9"
        />
        <path
          fill="#ffffff"
          d="M146.25 101.75 Q146.25 102.4 145.75 102.9 145.3 103.35 144.6 103.35 143.9 103.35 143.45 102.9 142.95 102.4 142.95 101.75 142.95 101.1 143.45 100.65 143.95 100.15 144.6 100.15 145.25 100.15 145.75 100.65 146.25 101.1 146.25 101.75"
        />
        <path
          fill="#0d131a"
          d="M206.3 129.15 Q205.95 127.5 206.55 127.6 207.15 127.75 208.1 129.75 L208.8 132.65 209.05 135.3 Q208.85 139.35 206.15 140.9 203.85 142.15 199.0 142.0 196.05 141.9 192.4 140.6 L185.15 137.8 Q181.15 136.45 176.2 135.2 L167.85 133.45 156.85 132.7 145.0 132.85 135.55 133.3 Q128.55 133.35 126.25 129.55 125.5 128.2 125.5 126.5 125.5 125.0 126.15 123.3 127.0 121.15 128.45 120.05 129.9 118.9 130.15 119.1 130.3 119.3 129.55 120.35 128.75 121.5 128.25 124.0 127.7 126.85 128.45 128.1 130.5 131.55 136.1 131.5 L144.95 131.35 157.5 131.1 169.2 131.9 Q175.45 132.8 184.9 136.05 L192.4 138.65 Q196.25 139.85 198.1 139.85 200.65 139.9 202.85 139.2 205.35 138.4 206.45 136.85 207.7 135.05 206.3 129.15"
        />
        <path
          fill="#0d131a"
          d="M207.65 129.7 Q221.35 129.95 221.45 141.55 221.45 145.85 219.55 150.85 217.9 155.15 215.75 157.75 208.05 167.15 190.15 170.55 176.6 173.1 162.7 171.7 136.5 169.1 122.35 156.3 108.85 144.15 113.1 129.6 114.5 124.75 118.05 122.3 122.2 119.4 128.7 120.05 129.2 120.95 127.6 121.25 123.95 121.0 120.7 123.35 117.45 125.7 115.75 129.9 113.65 135.1 115.65 141.35 117.75 147.8 123.6 153.55 137.55 167.2 163.45 169.75 L169.95 170.1 183.85 169.45 Q204.8 167.0 213.55 156.25 216.45 152.7 217.8 147.4 219.05 142.45 218.4 138.65 217.9 135.5 215.15 133.5 212.45 131.55 208.35 131.2 L208.0 130.55 207.65 129.7"
        />
      </g>
    </svg>
  );
};

export default Blastoise;
